/**
 * Generates discrete options for select dropdowns from 0 to 255 in steps of 5.
 * If the currentValue is not a multiple of 5, it is injected into the array
 * to prevent select options mismatch on initial load.
 *
 * @param {number} currentValue - The currently configured value of the parameter.
 * @returns {number[]} Sorted list of unique values.
 */
export const getVolumeAndBrightnessOptions = (currentValue) => {
  const steps = Array.from({ length: 52 }, (_, i) => i * 5);
  if (currentValue !== undefined && currentValue !== null && !steps.includes(currentValue)) {
    return [...steps, currentValue].sort((a, b) => a - b);
  }
  return steps;
};
